export default __webpack_public_path__ + "static/media/the_lick.8fb027c8.mp3";